import { AuthResponse, ValidateKeyResponse } from '../types/api';

const AUTH_CONFIG = {
  connect: '/api/auth/connect',
  account: (wallet: string) => `/api/auth/account/${wallet}`,
  validate: '/api/auth/validate'
};

export const authApi = {
  connect: async (wallet_address: string): Promise<AuthResponse> => {
    try {
      const response = await fetch(AUTH_CONFIG.connect, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ wallet_address }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error connecting wallet:', error);
      throw error;
    }
  },

  getAccount: async (wallet_address: string): Promise<AuthResponse> => {
    try {
      const response = await fetch(AUTH_CONFIG.account(wallet_address));
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching account:', error);
      throw error;
    }
  },

  validateKey: async (api_key: string): Promise<ValidateKeyResponse> => {
    try {
      const response = await fetch(AUTH_CONFIG.validate, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ api_key }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error validating API key:', error);
      throw error;
    }
  },
}; 